export default "__VITE_ASSET__DCAwU_vg__"